var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('feedback-modal',{attrs:{"data-test-id":"feedback-modal","is-loading":_vm.isLoading,"is-failed":_vm.isError,"on-close":_vm._close,"on-save":_vm._submitFeedback}})
}
var staticRenderFns = []

export { render, staticRenderFns }